const popupOpenClass = 'is-open';
const bodyPopupClass = 'popup-open';
const $body = $('body');

$(document).on('click', '.js-popup-trigger', function(event) {
  event.preventDefault();

  const $popupContainer = $(event.currentTarget.hash || event.currentTarget.dataset.popupTarget);

  if ($popupContainer.length) {
    $popupContainer.addClass(popupOpenClass);
    $body.addClass(bodyPopupClass);

    $popupContainer.find('input').first().focus();
  }
});

$(document).on('click', '.js-popup-close', function(event) {
  event.preventDefault();

  const $popupContainer = $(this).closest('.popup-container');

  $popupContainer.removeClass(popupOpenClass);
  $body.removeClass(bodyPopupClass);
});